import PhoneIcon from '@evaneos/b2b-ui/icons/LocalPhoneOutlined';
import { useIntl } from 'react-intl';

import { DisplayProject } from '../../../../resources/dossier-overview/types';
import { DossierId } from '../../../../resources/dossier/types';
import { DefinitionList } from '../../../../design-system/DefinitionList/DefinitionList';
import { useDossierLayoutInfo } from '../../DossierLayoutInfoContext';

import { PhoneNumberEditableItem } from './PhoneNumberEditableItem';

type PhoneNumberInfoProps = {
    project: DisplayProject | undefined;
    dossierId: DossierId;
};

export function PhoneNumberInfo({ project, dossierId }: PhoneNumberInfoProps) {
    const { formatMessage } = useIntl();
    const { isFirstColumnNarrow } = useDossierLayoutInfo();
    const phoneNumberLabelId = 'phone-number';

    return (
        <DefinitionList.Item>
            <DefinitionList.Label
                id={phoneNumberLabelId}
                icon={<PhoneIcon aria-hidden="true" fontSize="small" />}
                iconOnly={isFirstColumnNarrow}
            >
                {formatMessage({ id: 'dossier.information.traveller.phone' })}
            </DefinitionList.Label>
            <PhoneNumberEditableItem
                project={project}
                dossierId={dossierId}
                labelId={phoneNumberLabelId}
            />
        </DefinitionList.Item>
    );
}
